
	import {
		Component,
		Vue
	} from "vue-property-decorator";

	import PageFooter from '@/components/page-footer.vue';
	import Dialog from '@/components/dialog.vue';
	import {
		getAgentProductOrderDetail,
		orderCheck
	} from '@/api/order'
	import {
		grade,
	} from '@/utils/config'
	import {
		nextDay
	} from "@/utils"
	import {
		maxspecifications
	} from "@/utils/config"
	@Component({
		name: 'order_product-detail',
		components: {
			PageFooter,
			'slz-dialog': Dialog
		}
	})
	export default class OrderProductDetail extends Vue {
		private productId = +this.$route.query.id;
		private filterTime = this.$route.query.filterTime
		private IDKey = '';
		private productNameKey = '';
		private showCheckLog = false;
		private list: any = [];
		private pageNo = 1;
		private pageSize = 10;
		private total = 0;
		private checkLogs: any = [];
		private roleMap: any = grade;
		private orderState:any = [
			{
				name: '待审核',
				state:0,
				color: 'blue'
			},
			{
				name: '已取消',
				state:40,
				color: 'gary'
			},
			{
				name: '已完成',
				state:30,
				color: 'green'
			},
			{
				name: '售后中',
				color: 'red'
			},
			{
				name: '待发货',
				state:10,
				color: 'yellow'
			},
			{
				name: '已发货',
				state:20,
				color: 'yellow'
			},
			{
				name: '超时取消',
				color: 'gary'
			}
		]
		
		
		private popPageNo = 1;
		private popPageSize = 10;
		private popTotal = 0;
		private popId = 0;
		private tableloading=false
		private tableloading2=false
		
		// mounted() {
		// 	// console.log(123)
		// 	this.getList();
		// }
		activated () {
			this.productId = +this.$route.query.id
			this.filterTime = this.$route.query.filterTime
			this.getList();
		}

		private toDetail(id: number) {
			this.$router.push({
				name: 'Order_Detail',
				query: {
					id: id + ''
				}
			})
		}
		
		private popChangePage(e) {
			this.popPageNo = e;
			this.showLog(this.popId);
		}

		private async showLog(id: number) {
			this.popId = id;
			this.showCheckLog = true;
			try {
				this.tableloading2 = true
				const res: any = await orderCheck({
					Skip: (this.popPageNo-1)*this.popPageSize,
					Take: this.popPageSize,
					OrderNo: id
				})
				this.checkLogs = res.Result.Results;
				this.popTotal = res.Result.Total;
			} catch (e) {
				console.log(e)
			} finally{
				this.tableloading2 = false
			}
		}

		private doSearch() {
			this.pageNo = 1;
			this.getList();
		}

		private clearSearch() {
			this.IDKey = '';
			this.productNameKey = '';
			this.pageNo = 1;
			this.getList();
		}

		private handleClose() {
			this.showCheckLog = false;
			this.popPageNo = 1;
		}

		private changePage(e) {
			this.pageNo = e;
			this.getList()
		}

		private async getList() {
			let param: any = {
				Skip: (this.pageNo-1)*this.pageSize,
				Take: this.pageSize,
				ProductId: this.productId
			}
			if (this.productNameKey) {
				param.Keywords = this.productNameKey
			}
			if (this.filterTime) {
				var dt = String(this.filterTime).split('/');
				param.StartTime = dt[0];
				param.EndTime = nextDay(dt[1],1)
			}
			try {
				this.tableloading=true
				const res: any = await getAgentProductOrderDetail(param);
				this.list = res.Result.Results.map(v=>{
					let speclist:any = []
					for(let i=0;i<=maxspecifications;i++){
						let key = 'SpecValue' + (i==0?'':i)
						if(v[key]){
							speclist.push(v[key])
						}
					}
					v.SpecValueDisplay = speclist.join(';')
					return v
				})
				this.total = res.Result.Total;
			} catch (e) {
				console.log(e)
			} finally{
				this.tableloading  =false
			}
		}
	}
